/* Enlarged native product video, independent of cart and variant transactions. */
(() => {
  if (customElements.get('tb-video-expand')) return;
  customElements.define('tb-video-expand', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.inline = this.previousElementSibling;
      this.trigger = this.querySelector('[data-tb-video-open]');
      this.dialog = this.querySelector('dialog');
      if (!this.inline?.matches('video') || !this.trigger || !this.dialog || !this.dialog.showModal) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.stage = this.dialog.querySelector('[data-tb-video-stage]');
      this.closeButton = this.dialog.querySelector('[data-tb-video-close]');
      this.error = this.dialog.querySelector('[data-tb-video-error]');
      this.root = this.closest('tb-product');
      this.oldControlsList = this.inline.getAttribute('controlslist');
      // Use the visible expansion action in small cards, not the browser's cramped fullscreen icon.
      this.inline.controlsList?.add('nofullscreen');
      this.trigger.addEventListener('click', e => { e.preventDefault(); this.open(); }, {signal});
      this.closeButton.addEventListener('click', () => this.close(), {signal});
      this.dialog.addEventListener('cancel', e => { e.preventDefault(); this.close(); }, {signal});
      this.dialog.addEventListener('close', () => this.cleanup(true), {signal});
      this.dialog.addEventListener('click', e => {
        if (e.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.close();
      }, {signal});
      this.dialog.addEventListener('keydown', e => {
        if (e.key !== 'Tab' || !this.player) return;
        const links = [...this.dialog.querySelectorAll('button:not(:disabled),video,a[href]')].filter(x => x.getClientRects().length);
        const first = links[0], last = links.at(-1);
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }, {signal});
      this.root?.addEventListener('product:variant-change', () => this.close(), {signal});
      document.body.append(this.dialog);
    }
    disconnectedCallback() {
      this.cleanup(false);
      this.events?.abort(); this.events = null;
      if (this.inline) {
        if (this.oldControlsList === null) this.inline.removeAttribute('controlslist');
        else if (this.oldControlsList !== undefined) this.inline.setAttribute('controlslist', this.oldControlsList);
      }
      if (this.dialog) { this.dialog.close(); this.append(this.dialog); }
    }
    open() {
      if (!this.events || this.dialog.open) return;
      document.querySelectorAll('dialog.tb-video-dialog[open]').forEach(d => d.close());
      this.inline.pause();
      const time = Number.isFinite(this.inline.currentTime) ? this.inline.currentTime : 0;
      const v = this.player = this.inline.cloneNode(false);
      v.removeAttribute('id'); v.removeAttribute('style'); v.removeAttribute('autoplay'); v.removeAttribute('controlslist');
      v.removeAttribute('width'); v.removeAttribute('height');
      v.controls = true; v.playsInline = true; v.loop = false; v.preload = 'metadata'; v.tabIndex = 0;
      v.muted = this.inline.muted; v.volume = this.inline.volume; v.playbackRate = this.inline.playbackRate;
      v.src = this.trigger.href;
      this.error.hidden = true;
      v.addEventListener('loadedmetadata', () => {
        if (this.player !== v || !this.dialog.open) return;
        this.dialog.style.setProperty('--tb-video-ratio', String(v.videoWidth / v.videoHeight || 16 / 9));
        if (time > 0 && Number.isFinite(v.duration)) v.currentTime = Math.min(time, Math.max(0, v.duration - .05));
      }, {once:true});
      v.addEventListener('error', () => { if (this.player === v) this.error.hidden = false; }, {once:true});
      this.dialog.style.setProperty('--tb-video-ratio', String(this.inline.videoWidth / this.inline.videoHeight || 16 / 9));
      this.stage.replaceChildren(v);
      this.dialog.showModal();
      document.body.classList.add('tb-video-modal-open');
      this.closeButton.focus();
    }
    close() {
      if (!this.dialog?.open) return;
      this.cleanup(true);
      this.dialog.close();
    }
    cleanup(returnFocus) {
      const v = this.player;
      if (v) {
        v.pause();
        if (this.inline?.isConnected && Number.isFinite(v.currentTime) && v.readyState > 0) {
          try { this.inline.currentTime = v.currentTime; this.inline.muted = v.muted; this.inline.volume = v.volume; } catch (_) { /* Detached or unseekable source. */ }
        }
        v.removeAttribute('src'); v.load(); this.stage.replaceChildren(); this.player = null;
      }
      if (!document.querySelector('dialog.tb-video-dialog[open]:not(#' + CSS.escape(this.dialog?.id || '') + ')')) document.body.classList.remove('tb-video-modal-open');
      if (returnFocus && this.trigger?.isConnected) this.trigger.focus({preventScroll:true});
    }
  });
})();
